import React from 'react';
import { SxStyle } from '../../../types';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Grid2';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';

const styles: SxStyle = {
  noBorder: {
    pt: '8px',
    pb: '6px',
  },
  border: {
    pt: '0px',
    pb: '15px',
    mb: '10px',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderBottomColor: 'rgb(0, 0, 0, 12%)',
  },
};

export interface SceneHeaderProps {
  title?: string;
  border?: boolean;
  children?: React.ReactNode;
  backButton?: string;
}

const SceneHeader = ({ title, border, children, backButton }: SceneHeaderProps) => {
  const history = useHistory();
  return (
    <Grid2 spacing={2} container alignItems="center" sx={border ? styles.border : styles.noBorder}>
      {title || backButton ? (
        <>
          <Grid2 sx={{ flexShrink: 0, display: 'flex', gap: 2, alignItems: 'center' }}>
            {backButton ? (
              <IconButton
                onClick={() => {
                  history.push(backButton);
                }}
                size="small"
                sx={{ color: 'primary.main' }}
              >
                <ArrowBackIcon />
              </IconButton>
            ) : null}
            {title ? <Typography variant="h5">{title}</Typography> : null}
          </Grid2>
        </>
      ) : null}
      <Grid2 size="grow" />
      <Grid2 container>{children}</Grid2>
    </Grid2>
  );
};

export default SceneHeader;
